<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>ARCHITECTURE</div>
				<h2 waHeading="l" waText>How JWebMP Works</h2>
				<p waBody="m" waColorText="quiet" waText>A layered, modular architecture &mdash; each layer does one thing well.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<p waBody="m" waText>JWebMP is a layered architecture where each layer has a single responsibility. The foundation is GuicedEE &#40;dependency injection, SPI discovery, Vert.x lifecycle&#41;. JWebMP Core adds the HTML/CSS/JS component model. Plugins extend it with specific component libraries. The Angular layer generates the frontend. At runtime, Vert.x serves everything reactively. Explore each layer via the menu tree.</p>
				<div class="mermaid-diagram">
					<markdown [data]="mdContent_2" mermaid></markdown>
				</div>
			</div>
		</div>
	</div>
</div>